(function () {
  const BADGE_SELECTOR = '.pdp-mobile-save-badge';

  function setHidden(hidden) {
    document.querySelectorAll(BADGE_SELECTOR).forEach((el) => {
      el.style.display = hidden ? 'none' : '';
    });
  }

  function isMenuDrawerOpen() {
    // Dawn: cuando el menú móvil está abierto, existe details[open] dentro del contenedor del menú
    const openMenu = document.querySelector('.header__icon--menu details[open], .menu-drawer-container details[open]');
    if (openMenu) return true;

    // Fallback: drawer visible
    const drawer = document.querySelector('.menu-drawer');
    if (drawer) {
      const style = window.getComputedStyle(drawer);
      if (style.visibility !== 'hidden' && style.display !== 'none') {
        // si está abierto, suele tener transform distinto a "none"
        return true;
      }
    }
    return false;
  }

  function sync() {
    setHidden(isMenuDrawerOpen());
  }

  // 1) Inicial
  sync();

  // 2) Clicks (abrir/cerrar)
  document.addEventListener('click', () => setTimeout(sync, 0), true);

  // 3) Cambios DOM (Shopify abre/cierra drawer sin recargar)
  const obs = new MutationObserver(sync);
  obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true });
})();
